import axios from 'axios';
import React, { Component } from 'react';

// Components

export class VideoList extends Component  {
  state = {
    isLoaded: false, videos: []
  }

  componentDidMount() {
    const googleAPI = process.env.REACT_APP_GOOGLEAPI;
    const googleAPI_Key = process.env.REACT_APP_GOOGLEAPIKEY;

    axios.get(googleAPI+'/playlistItems', {
      params: {
        part: 'snippet,id',
        maxResults: this.props.count,
        key: googleAPI_Key,
        playlistId: 'PLx9J53NyYBSNiocDLwQM3obxJaG1LOUUS'
      }
    })
    .then(res => {
      this.setState({ videos: res.data.items, isLoaded: true })
      // console.dir(res);
    });
  }

  videoClick = (e) => {
    console.log(e.target.dataset.videoid);
    // window.location.href = '/event?eventid=' + e.target.dataset.eventid;
  }

  render() {
    const { isLoaded, videos } = this.state;
    // console.dir(this.state);

    return (
      <>
        {(isLoaded && videos != null) && (
          <aside className="videoList">
            <h2><i className="fab fa-youtube"></i> Past Event Videos</h2>

            {videos.map((v, index) =>
              <div className="video" key={ index }>
                <a href={ '/video?videoid=' + v.snippet.resourceId.videoId }>
                  <img src={ v.snippet.thumbnails.medium.url } alt={ v.snippet.title } />
                  <div className="vidInfo">
                    <p className="title"> { v.snippet.title }</p>
                    <p className="categ"> { v.snippet.channelTitle }</p>
                  </div>
                </a>
              </div>
            )}

            <p className="more"><a href="/allvideos">View All Videos <i className="fas fa-chevron-double-right"></i></a></p>

          </aside>
        )}
      </>
    );
  }
}

export default VideoList;